import { render } from "./PeriodicityList.vue?vue&type=template&id=6b421d48&scoped=true"
import script from "./PeriodicityList.vue?vue&type=script&lang=js"
export * from "./PeriodicityList.vue?vue&type=script&lang=js"

import "./PeriodicityList.vue?vue&type=style&index=0&id=6b421d48&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b421d48"]])

export default __exports__